// src/seoConfig.js

// Primary / new domain for all canonical URLs
const PRIMARY_BASE = "https://greenworksnw.com";

// Canonical targets – always point to the new domain
const CANONICALS = {
  "/": `${PRIMARY_BASE}/`,
  "/about": `${PRIMARY_BASE}/about`,
  "/pricing-details": `${PRIMARY_BASE}/pricing-details`,
  "/privacy": `${PRIMARY_BASE}/privacy`,
  "/services": `${PRIMARY_BASE}/services`,
  "/terms": `${PRIMARY_BASE}/terms`,
  "/contact": `${PRIMARY_BASE}/contact`,
};

const DOMAIN_CONFIGS = {
  // New domain
  "greenworksnw.com": {
    baseUrl: PRIMARY_BASE,
    seo: {
      "/": {
        title: "Cleaning Services Lynnwood, WA | Greenworks Carpet Cleaning",
        description:
          "Get professional carpet & upholstery cleaning in Lynnwood WA. Greenworks provides eco-friendly, deep cleaning with same day service. Request a free quote today.",
        canonical: CANONICALS["/"],
      },
      "/about": {
        title: "About Us | Residential Carpet Cleaners in Lynnwood, WA",
        description:
          "Our commitment is to provide safe, eco-friendly cleaning for healthier homes. Enjoy trusted professionals, pet-safe products & 100 percent satisfaction always.",
        canonical: CANONICALS["/about"],
      },
      "/pricing-details": {
        title: "Transparent Cleaning Service Pricing | Deep Cleaning Rates",
        description:
          "Find clear prices on carpet, tile, rug, and upholstery cleaning. Enjoy eco-friendly treatments, stain removal, and free deodorizing. Book your service today.",
        canonical: CANONICALS["/pricing-details"],
      },
      "/privacy": {
        title: "Privacy Policy and Data Protection for Our Cleaning Services",
        description:
          "Learn how your personal information is collected, used, and protected when you use our cleaning services. We are committed to your privacy and data security.",
        canonical: CANONICALS["/privacy"],
      },
      "/services": {
        title: "Professional Cleaning Services Lynnwood, WA | Local Cleaners",
        description:
          "Explore professional carpet, tile, grout, hardwood & upholstery cleaning services by Greenworks. Enjoy eco-friendly solutions and same day service. Learn more.",
        canonical: CANONICALS["/services"],
      },
      "/terms": {
        title: "Terms and Conditions for Greenworks Cleaning Services",
        description:
          "Read the terms and conditions for using Greenworks services. Find details on service agreements, customer responsibilities & important legal information here.",
        canonical: CANONICALS["/terms"],
      },
      "/contact": {
        title: "Contact Us for Expert Tile & Grout Cleaning | Lynnwood, WA",
        description:
          "Reach out to Greenworks for questions or to book a cleaning service. Call, email, or send a message and our friendly team will respond quickly to your requests.",
        canonical: CANONICALS["/contact"],
      },
    },
  },

  // Old domain – still serves the site, but all canonicals point to PRIMARY_BASE
  "greenworkscarpetcleaning.com": {
    baseUrl: "https://www.greenworkscarpetcleaning.com",
    seo: {
      "/": {
        title: "Cleaning Services Lynnwood, WA | Greenworks Carpet Cleaning",
        description:
          "Get professional carpet & upholstery cleaning in Lynnwood WA. Greenworks provides eco-friendly, deep cleaning with same day service. Request a free quote today.",
        canonical: CANONICALS["/"],
      },
      "/about": {
        title: "About Us | Residential Carpet Cleaners in Lynnwood, WA",
        description:
          "Our commitment is to provide safe, eco-friendly cleaning for healthier homes by trusted professionals, pet-safe products & 100 percent satisfaction always.",
        canonical: CANONICALS["/about"],
      },
      "/pricing-details": {
        title: "Transparent Cleaning Service Pricing | Deep Cleaning Rates",
        description:
          "Find clear prices on carpet, tile, rug, and upholstery cleaning. Enjoy eco-friendly treatments, stain removal, and free deodorizing. Book your service today.",
        canonical: CANONICALS["/pricing-details"],
      },
      "/privacy": {
        title: "Privacy Policy and Data Protection for Our Cleaning Services",
        description:
          "Learn how your personal information is collected, used, and protected when you use our cleaning services. We are committed to your privacy and data security.",
        canonical: CANONICALS["/privacy"],
      },
      "/services": {
        title: "Professional Cleaning Services Lynnwood, WA | Local Cleaners",
        description:
          "Explore professional carpet, tile, grout, hardwood & upholstery cleaning services by Greenworks. Enjoy eco-friendly solutions and same day service. Learn more.",
        canonical: CANONICALS["/services"],
      },
      "/terms": {
        title: "Terms and Conditions for Greenworks Cleaning Services",
        description:
          "Read the terms and conditions for using Greenworks services. Find details on service agreements, customer responsibilities & important legal information here.",
        canonical: CANONICALS["/terms"],
      },
      "/contact": {
        title: "Contact Us for Expert Tile & Grout Cleaning | Lynnwood, WA",
        description:
          "Reach out to Greenworks for questions or to book a cleaning service. Call, email, or send a message and our friendly team will respond quickly to your requests.",
        canonical: CANONICALS["/contact"],
      },
    },
  },
};

// Detect which domain we’re on (new or old)
const hostname =
  typeof window !== "undefined"
    ? window.location.hostname.replace(/^www\./, "")
    : "greenworksnw.com";

const activeConfig =
  DOMAIN_CONFIGS[hostname] || DOMAIN_CONFIGS["greenworksnw.com"];

export const seoConfig = activeConfig.seo;

// Prefer explicit canonical from seoConfig; but always fall back to PRIMARY_BASE
export const buildCanonical = (path) => {
  const entry = seoConfig[path];

  if (entry && entry.canonical) return entry.canonical;

  // Fallback: still use the NEW domain, never the old one
  return `${PRIMARY_BASE}${path === "/" ? "/" : path}`;
};
